import React from "react";

import AdminLayout from "../../components/AdminLayout";
export default function Users() {
  return <AdminLayout>Users</AdminLayout>;
}
